import React, { useContext } from 'react';
import { StepperHeader } from './StepperHeader';
import {
	onClickNext,
	onClickPrevious,
	NextButton,
	PreviousButton,
	IrAFinalizadoButton
} from './StepperButtons';
import './styles.scss';

/**
 * stepperState:
 * {
 *	currentIndex: 0,
 *	currentStep: 'foo',
 * 	steps: {
 * 	  foo: { label: 1, title: "Ejemplo 1" },
 * 	  bar: { label: 1, title: "Ejemplo 2" },
 *   },
 *   elements: [
 * 	  { step: 'foo' },
 * 	  { step: 'bar', sub_step: 1 },
 * 	  { step: 'bar', sub_step: 2 },
 *   ]
 * }
 * */
const StepperContext = React.createContext({
	stepperState: {
		currentIndex: 0,
		currentStep: '',
		steps: {},
		elements: []
	},
	setStepperState: (newState) => newState,
	stpLoading: false,
	setStpLoading: (newState) => newState
});

const StepperProvider = ({ initialContext, children }) => {
	return (
		<StepperContext.Provider value={initialContext}>
			{children}
		</StepperContext.Provider>
	);
};

export const StepWrapper = ({ index = false, children }) => {
	const { stepperState } = useContext(StepperContext);

	return stepperState?.currentIndex === index && children;
};

export {
	StepperContext,
	StepperProvider,
	StepperHeader,
	onClickNext,
	onClickPrevious,
	NextButton,
	PreviousButton,
	IrAFinalizadoButton
};
